import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import ceoImg from "../assets/ceo.png";
import path from "../assets/path.png";

const CEODesk = () => {
  return (
    <>
      <div className="container my-0">
        <div className="row align-items-center">
          {/* Left Part - CEO Message */}
          <div className="col-md-6">
            <h1 className="fw-bold">From the CEO's Desk</h1>
            <h3 className="fw-bold">A Legacy of Innovation & Excellence</h3>

            <p>
              As the CEO of{" "}
              <span className="fw-bold">
                <span style={{ color: "#d53539" }}>Time</span>  
                <span style={{ color: "#6e7072" }}>Watch</span>
              </span>
              , I am honored to share our journey with you. Since our founding
              in 2015,{" "}
              <span className="fw-bold">TimeWatch Infocom Pvt. Ltd. </span>has
              been at the forefront of{" "}
              <span className="fw-bold">Security Solutions.</span> We are
              dedicated to:
              <ul className="mt-3">
                <li>
                  <b>Innovating Security:</b> Using <b>AI</b> and{" "}
                  <b>Machine Learning</b> to create smart, adaptive solutions.
                </li>
                <li>
                  <b>Advanced Technology:</b> Offering cutting-edge{" "}
                  <b>security systems</b> that keep our clients secure in a
                  digital world.
                </li>
                <li>
                  <b> Creative Team:</b> A passionate team driving continuous
                  <b> innovation and technological excellence</b>.
                </li>
                <li>
                  <b>Client Trust:</b> Building <b>reliable, future-proof </b>
                  solutions that ensure peace of mind
                </li>
              </ul>
            </p>

            <p>
              Our mission is clear: to <b>empower</b> businesses and individuals
              with the most <b>advanced security</b> products, and to lead the
              way in
              <b> security innovation</b> for the future.
            </p>
          </div>

          {/* Right Part - CEO Image and Quote */}
          <div className="col-md-6 text-center">
            <img
              src={ceoImg}
              alt="CEO"
              className="img-fluid  mb-3"
              style={{
                width: "100%", // Defaults to full width of the parent container
                maxWidth: "480px", // Restricts the maximum size
                height: "auto", // Maintains aspect ratio
                objectFit: "cover", // Ensures the image scales correctly without distortion
                borderRadius: "50%",
                border: '2px solid black'
              }}
            />
            <h2>Mr. Virendra Kumar</h2>
            <p className="fst-italic">
              “Innovation is the key to enhancing security and empowering
              businesses for the future.”
            </p>
          </div>

          <div className="container my-5">
            <div className="row align-items-center">
              {/*<div className="col-md-6 text-center mr-4">
                {" "}
                <video
                  src={statsvi}
                  autoPlay
                  muted
                  loop
                  className="img-fluid"
                  alt="stats"
                  style={{ width: "100%" }}
                />
              </div>

              
              <div className="col-md-6">
                <p>
                  As the CEO of TimeWatch Infocom Pvt. Ltd., I am proud to share
                  our remarkable journey since our establishment in 2015.
                  TimeWatch has grown into a leader in biometric-based security
                  solutions, specializing in time management, access control,
                  and comprehensive security services. Our expertise allows us
                  to provide end-to-end solutions tailored to the needs of
                  businesses and individuals alike. With a strong focus on
                  innovation and customer satisfaction, we have consistently
                  delivered cutting-edge technology that ensures the highest
                  standards of security and efficiency. At TimeWatch, we are
                  dedicated to safeguarding the future with reliable, advanced,
                  and customized solutions.
                </p>
              </div>*/}
            </div>
          </div>

          <div className="container my-5">
            <div className="row align-items-center">
              {/* Left Part - Product Description */}
              <div className="col-md-6">
                <h1>Our Product Range</h1>
                <p>
                  At TimeWatch, we offer a versatile suite of products designed
                  to meet the evolving demands of today’s businesses. Our
                  solutions are scalable, user-friendly, and reliable, ensuring
                  seamless management across various sectors. Discover our
                  comprehensive offerings:
                </p>
                <ul>
                  <li>Time & Attendance Solutions</li>
                  <li>Access Control Solutions</li>
                  <li>Entrance Control Solutions</li>
                  <li>Traffic & Parking Control Solutions</li>
                  <li>Inspection Control Solutions</li>
                  <li>Software & Mobile Applications</li>
                  <li>UL Listed EM Locks & Accessories</li>
                </ul>
                <p className="fw-bold">
                  Each solution is crafted to enhance operational efficiency,
                  productivity, and security, making TimeWatch a trusted partner
                  for modern organizations.
                </p>
              </div>

              {/* Right Part - Product Image */}
              <div className="col-md-6 text-center">
                <img
                  src="https://timewatch.co.in/images/Our-Solutions.jpg"
                  alt="solutions"
                  className="img-fluid"
                />
              </div>
            </div>
          </div>

          {/*<div
            className="container text-center py-5" 
            data-aos="fade-up"
            data-aos-easing="ease-in-out"
          >
            <div className=" rounded p-4 mb-2">
              <h2 className="text-dark fw-bold">
                WHY CHOOSE <span className="text-danger">TIME</span>
                <span className="text-secondary">WATCH</span>?
              </h2>
            </div>

            <div className="row">
              <div className="col-md-12">
                <p className="text-start px-2">
                  We are recognized as an Original Equipment Manufacturer (OEM)
                  and service provider specializing in Biometric Time Attendance
                  Systems, Inspection Control Systems, Access Control Systems,
                  and their accessories. Our products are available in a variety
                  of configurations to meet the specific needs of our customers.
                </p>
              </div>
              <div className="col-md-12">
                <div className="row justify-content-center mt-4">
                  <div className="col-6 col-sm-4 col-md-2 text-center mb-3">
                    <img src={i1} alt="Info Icon" className="img-fluid" />
                    <p className="fw-bold mt-2">
                      END TO END SECURITY SOLUTIONS
                    </p>
                  </div>

                  <div className="col-6 col-sm-4 col-md-2 text-center mb-3">
                    <img src={i2} alt="Info Icon" className="img-fluid" />
                    <p className="fw-bold mt-2">COMMITMENT OF QUALITY</p>
                  </div>

                  <div className="col-6 col-sm-4 col-md-2 text-center mb-3">
                    <img src={i3} alt="Info Icon" className="img-fluid" />
                    <p className="fw-bold mt-2">PAN INDIA PRESENCE</p>
                  </div>

                  <div className="col-6 col-sm-4 col-md-2 text-center mb-3">
                    <img src={i4} alt="Info Icon" className="img-fluid" />
                    <p className="fw-bold mt-2">ONE STOP SOLUTION</p>
                  </div>

                  <div className="col-6 col-sm-4 col-md-2 text-center mb-3">
                    <img src={i5} alt="Info Icon" className="img-fluid" />
                    <p className="fw-bold mt-2">EXCELLENCE IN SERVICE</p>
                  </div>

                  <div className="col-6 col-sm-4 col-md-2 text-center mb-3">
                    <img src={i6} alt="Info Icon" className="img-fluid" />
                    <p className="fw-bold mt-2">ONLINE SUPPORT</p>
                  </div>
                </div>
              </div>
            </div>
          </div>*/}

          <div className="container my-5">
            {/* Mission & Vision Section */}
            <div className="row align-items-center">
              {/* Left Part - Image */}
              <div className="col-md-6 text-center">
                <img src={path} alt="stats" className="img-fluid" />
              </div>

              {/* Right Part - Mission Text */}
              <div className="col-md-6">
                <div>
                  <h2>Our Mission & Vision: The Road Ahead</h2>
                  <h3>Our mission at TimeWatch is simple yet powerful:</h3>
                  <p>Identify | Innovate | Build | Supply | Support.</p>
                  <p className="mt-4" style={{ fontSize: "1.1rem" }}></p>
                  <p className="mt-4" style={{ fontSize: "1.1rem" }}>
                    As we look to the future, we remain focused on:
                  </p>
                  <ul className="mt-3">
                    <li>
                      <strong>Research & Development</strong>: Continuous
                      investment to ensure we stay ahead of industry trends.
                    </li>
                    <li>
                      <strong>Expanding Our Product Portfolio</strong>:
                      Launching new products to meet evolving market demands.
                    </li>
                    <li>
                      <strong>Strengthening Partnerships</strong>: Collaborating
                      with key stakeholders to better serve our clients
                      globally.
                    </li>
                    <li>
                      <strong>Sustainability and Responsibility</strong>:
                      Committing to eco-friendly practices and responsible
                      sourcing to create a positive impact on the environment
                      and society.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="container my-5">
            <div className="text-center mb-4">
              <h2 className="fw-bold">Industries We Serve</h2>
            </div>
            <div className="row">
              <div className="col-12">
                <p>
                  Our solutions are trusted by a diverse array of industries,
                  delivering tailored security and management systems that meet
                  their unique needs. We are proud to serve clients from sectors
                  such as{" "}
                  <span className="fw-bold">
                    Banking and Financial Services, Army and Defense, and
                    Healthcare,
                  </span>{" "}
                  where precision and reliability are paramount.
                </p>
                <p>
                  In the{" "}
                  <span className="fw-bold">
                    Public Sector, Hotels and Resorts, and IT & Telecom,
                  </span>{" "}
                  we provide cutting-edge solutions that streamline operations
                  and enhance security. Schools and Institutions, Railways, and
                  Airports rely on our expertise to maintain smooth and secure
                  environments.
                </p>
                <p>
                  We also partner with{" "}
                  <span className="fw-bold">
                    Corporate Offices, Residential Societies, and the Retail
                    Industry,
                  </span>{" "}
                  empowering them with advanced, scalable solutions to ensure
                  optimal security and efficiency.
                </p>
              </div>
            </div>
          </div>

          {/*<div className="container my-5">
            <div className="row align-items-center">
              <div className="col-md-6">
                <h1>Looking to the Future</h1>
                <p>
                  As we embark on this exciting journey, we are filled with
                  optimism about the opportunities that lie ahead. Our
                  unwavering commitment to innovation and growth drives us to
                  explore new frontiers and enhance our services. At TimeWatch,
                  we believe that excellence is not just a goal but a standard
                  we strive to uphold in every aspect of our operations.
                </p>
                <p>
                  We are dedicated to delivering exceptional value to our
                  stakeholders, ensuring that our solutions meet their evolving
                  needs. Together, we can redefine industry standards and create
                  a brighter, more secure future. Join us as we shape the future
                  of security and make a lasting impact in our community.
                </p>
              </div>

              <div className="col-md-6 text-center">
                <img src={secure} alt="ceo-img" className="img-fluid" />
              </div>
            </div>
          </div> */}

          <div className="container my-5">
            {/* Heading */}
            <div className="text-center mb-4">
              <h2 className="heading" style={{ color: "black" }}>
                Discover How TimeWatch Can Transform Your Operations
              </h2>
            </div>

            {/* Content */}
            <div className="row">
              <div className="col-md-12">
                <div>
                  <div>
                    {/* Each paragraph is separated for clear stacking */}
                    <p className=" mb-3">
                      Are you curious about how TimeWatch’s advanced solutions
                      can enhance your business’s efficiency and security? We
                      invite you to explore our comprehensive range of products
                      designed to meet the dynamic needs of modern
                      organizations.
                    </p>
                    <p className=" mb-3">
                      Our offerings are tailored to address diverse challenges
                      across various industries, providing you with the tools
                      needed to streamline operations, ensure safety, and drive
                      productivity. Whether you’re interested in time
                      management, access control, or any other of our
                      specialized solutions, we’re here to guide you through our
                      innovative products.
                    </p>
                    <p className=" mb-3">
                      For a more in-depth understanding of how our solutions can
                      be customized to fit your specific requirements, we
                      encourage you to reach out for a personalized
                      consultation. Our team of experts is ready to discuss your
                      needs, answer your questions, and provide you with the
                      insights necessary to make informed decisions.
                    </p>
                    <p>
                      <span className="fw-bold">
                        Get in touch with us today
                      </span>{" "}
                      to schedule a consultation and discover how TimeWatch can
                      support your organization’s goals. Together, we can build
                      a more secure and efficient future for your business.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CEODesk;
